module.exports = __webpack_public_path__ + "img/LazyLoad.c6c54dde.svg";